import {Action} from '@ngrx/store';
import {GetOrganizationsRequest, GetSelfOrganizationRequest, Organization, PostOrganizationRequest} from '../models/organization';
import {ErrorPayload} from '../models/general';

export enum OrganizationActionTypes {
  GetOrganizations = '[Organization] Get Organizations',
  GetOrganizationsComplete = '[Organization] Get Organizations Complete',
  GetOrganizationsError = '[Organization] Get Organizations Error',
  GetSelfOrganization = '[Organization] Get Self Organization',
  GetSelfOrganizationComplete = '[Organization] Get Self Organization Complete',
  GetSelfOrganizationError = '[Organization] Get Self Organization Error',
  PostOrganization = '[Organization] Post Organization',
  PostOrganizationComplete = '[Organization] Post Organization Complete',
  PostOrganizationError = '[Organization] Post Organization Error'
}

export class GetOrganizations implements Action {
  readonly type = OrganizationActionTypes.GetOrganizations;

  constructor(public payload: GetOrganizationsRequest) {
  }
}

export class GetOrganizationsComplete implements Action {
  readonly type = OrganizationActionTypes.GetOrganizationsComplete;

  constructor(public payload: Organization[]) {
  }
}

export class GetOrganizationsError implements Action {
  readonly type = OrganizationActionTypes.GetOrganizationsError;

  constructor(public payload: ErrorPayload) {
  }
}

export class GetSelfOrganization implements Action {
  readonly type = OrganizationActionTypes.GetSelfOrganization;

  constructor(public payload: GetSelfOrganizationRequest) {
  }
}

export class GetSelfOrganizationComplete implements Action {
  readonly type = OrganizationActionTypes.GetSelfOrganizationComplete;

  constructor(public payload: Organization) {
  }
}

export class GetSelfOrganizationError implements Action {
  readonly type = OrganizationActionTypes.GetSelfOrganizationError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PostOrganization implements Action {
  readonly type = OrganizationActionTypes.PostOrganization;

  constructor(public payload: PostOrganizationRequest) {
  }
}

export class PostOrganizationComplete implements Action {
  readonly type = OrganizationActionTypes.PostOrganizationComplete;

  constructor(public payload: Organization) {
  }
}

export class PostOrganizationError implements Action {
  readonly type = OrganizationActionTypes.PostOrganizationError;

  constructor(public payload: ErrorPayload) {
  }
}

export type OrganizationActions =
  | GetOrganizations
  | GetOrganizationsComplete
  | GetOrganizationsError
  | GetSelfOrganization
  | GetSelfOrganizationComplete
  | GetSelfOrganizationError
  | PostOrganization
  | PostOrganizationComplete
  | PostOrganizationError;
